import FooterListItem from './FooterListItem';

export default FooterListItem;
